export default __webpack_public_path__ + "static/banner-c4ad238beceb9886424d6c95e794d20e.svg";